/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQOptionUpdate } from './mCQOptionUpdate';
import type { MCQQuestionUpdateExplanation } from './mCQQuestionUpdateExplanation';
import type { MCQQuestionUpdateDifficulty } from './mCQQuestionUpdateDifficulty';
import type { MCQQuestionUpdateImageUrl } from './mCQQuestionUpdateImageUrl';
import type { MCQQuestionUpdateImageAlt } from './mCQQuestionUpdateImageAlt';

/**
 * Request to update an MCQ question (without ID which is in URL).
 */
export interface MCQQuestionUpdate {
  text: string;
  /**
   * Must have at least 2 options
   * @minItems 2
   */
  options: MCQOptionUpdate[];
  explanation?: MCQQuestionUpdateExplanation;
  difficulty?: MCQQuestionUpdateDifficulty;
  imageUrl?: MCQQuestionUpdateImageUrl;
  imageAlt?: MCQQuestionUpdateImageAlt;
}
